export const MainNavigation = {
  HOME: '/',
  PHONES: '/phones',
  TABLETS: '/tablets',
  ACCESSORIES: '/accessories',
  FAVOURITES: '/favourites',
  CART: '/cart',
  NOT_FOUND: '*',
};

export enum Theme {
  LIGTH = 'light-theme',
  DARK = 'dark-theme',
}
